import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountCode  {
    _originalTypeClassName = "zERP.BO.AccountCode";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountCode.translate = translateService;
}
this.Segments = [];
this.Id = null;
this.Levels = null;
this.FillAllLevels = false;
this.DefaultCharacter = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Levels:any;
FillAllLevels:any;
DefaultCharacter:any;
Segments:any;
static setSegments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Segments == null) $this.Segments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Segments.length > 0) {
                    Domain.AccountCode.removeSegments($this, $this.Segments[0]);
                }

                Domain.AccountCode.addManySegments($this, copyItems);
            }
static addManySegments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountCode.addSegments($this, items[i]);
                }
            }
static addSegments = ($this, item) => {
                if ($this.Segments == null) $this.Segments = [];
                if (item == null || $this.Segments.indexOf(item) > -1) return;
                $this.Segments.push(item);
}
static addRangeSegments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountCode.addSegments($this, item));
            }
static removeSegments = ($this, item) => {
                if ($this == null || $this.Segments == null || $this.Segments.indexOf(item) === -1) return;
                var _index = $this.Segments.indexOf(item);
                $this.Segments.splice(_index, 1);
}
static clearSegments = ($this) => { $this.Segments = null; }

static GetLastPart($this: any, fullCode: any): any{let codeLevel = Domain.AccountCode.GetLevel($this, fullCode);
let lastSegment = null;
let placeInString = 0;
for (let _isegment = 0; _isegment < ($this?.Segments?.linq?.take(Joove.Common.safeNumber(codeLevel) - Joove.Common.safeNumber(1))?.toArray() == null ? 0 : $this?.Segments?.linq?.take(Joove.Common.safeNumber(codeLevel) - Joove.Common.safeNumber(1))?.toArray().length); _isegment++) {let segment = $this?.Segments?.linq?.take(Joove.Common.safeNumber(codeLevel) - Joove.Common.safeNumber(1))?.toArray()[_isegment];placeInString = Joove.Common.safeNumber(placeInString) + Joove.Common.safeNumber(segment?.Length);if (!(CLMS.Framework.String.IsNullOrEmpty((segment?.Seperator ?? '').trim()))) {placeInString = Joove.Common.safeNumber(placeInString) + Joove.Common.safeNumber(segment?.Seperator?.length);}lastSegment = segment;}
return fullCode?.substr(placeInString);
}
static GetLevel($this: any, code: any): any{let placeInString = 0;
let levelNumber = 1;
let lastNonZero = 1;
for (let _isegment = 0; _isegment < ($this?.Segments == null ? 0 : $this?.Segments.length); _isegment++) {let segment = $this?.Segments[_isegment];let currentLevelValue = code?.substr(placeInString, segment?.Length);placeInString = Joove.Common.safeNumber(placeInString) + Joove.Common.safeNumber(segment?.Length);if (!(CLMS.Framework.String.IsNullOrEmpty((segment?.Seperator ?? '').trim()))) {placeInString = Joove.Common.safeNumber(placeInString) + Joove.Common.safeNumber(segment?.Seperator?.length);}if (Joove.Common.replaceAll(currentLevelValue, "0", "$") != "$") {lastNonZero = levelNumber;}if (CLMS.Framework.Number.GreaterThan(() => placeInString, () => code.length)) {return lastNonZero;}levelNumber = Joove.Common.safeNumber(levelNumber) + Joove.Common.safeNumber(1);}
return lastNonZero;
}
static GetParent($this: any, code: any): any{let codeLevel = Domain.AccountCode.GetLevel($this, code);
let lastSegment = null;
let placeInString = 0;
for (let _isegment = 0; _isegment < ($this?.Segments?.linq?.take(Joove.Common.safeNumber(codeLevel) - Joove.Common.safeNumber(1))?.toArray() == null ? 0 : $this?.Segments?.linq?.take(Joove.Common.safeNumber(codeLevel) - Joove.Common.safeNumber(1))?.toArray().length); _isegment++) {let segment = $this?.Segments?.linq?.take(Joove.Common.safeNumber(codeLevel) - Joove.Common.safeNumber(1))?.toArray()[_isegment];placeInString = Joove.Common.safeNumber(placeInString) + Joove.Common.safeNumber(segment?.Length);if (!(CLMS.Framework.String.IsNullOrEmpty((segment?.Seperator ?? '').trim()))) {placeInString = Joove.Common.safeNumber(placeInString) + Joove.Common.safeNumber(segment?.Seperator?.length);}lastSegment = segment;}
if (CLMS.Framework.Number.GreaterThan(() => placeInString, () => code.length)) {return null;}
let parentCode = code?.substr(0, placeInString);
for (let _isegment = 0; _isegment < ($this?.Segments?.linq?.skip(Joove.Common.safeNumber(codeLevel) - Joove.Common.safeNumber(1))?.toArray() == null ? 0 : $this?.Segments?.linq?.skip(Joove.Common.safeNumber(codeLevel) - Joove.Common.safeNumber(1))?.toArray().length); _isegment++) {let segment = $this?.Segments?.linq?.skip(Joove.Common.safeNumber(codeLevel) - Joove.Common.safeNumber(1))?.toArray()[_isegment];if (segment?.Optional) {break;}lastSegment = segment;parentCode = parentCode + CLMS.Framework.String.FillWith('0', segment?.Length);if (!(CLMS.Framework.String.IsNullOrEmpty((segment?.Seperator ?? '').trim()))) {parentCode = parentCode + segment?.Seperator;}}
if (lastSegment != null && !(CLMS.Framework.String.IsNullOrEmpty((lastSegment?.Seperator ?? '').trim()))) {parentCode = parentCode?.substr(0, Joove.Common.safeNumber(parentCode?.length) - Joove.Common.safeNumber(lastSegment?.Seperator?.length));}
return parentCode;
}
static Validate($this: any, code: any,level: any): any{if (CLMS.Framework.Number.GreaterThan(() => level, () => $this.Levels)) {console.warn("Out of levels limit");return false;}
let segment = $this?.Segments[Joove.Common.safeNumber(level) - Joove.Common.safeNumber(1)];
if (CLMS.Framework.Number.NotEqual(() => segment.Length, () => code.length)) {console.warn("Length is not correct. expecting: " + Joove.Common.safeNumber(segment?.Length));return false;}
return true;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}